module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqBAMAAAA37dRoAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURTNv/0dwTDFu/zJw/zBq/zJu/zNv/zNv/zJu/zBw/0903+4AAAAKdFJOU/8AQF8dgp/NcDBvO9vDAAAAd0lEQVQoz2MQxAYYcIt6hCJACExUkgEZBEJFxVFEmaCiCkA2qzEINIBYSKKMYFtAutiQ1SqBgAKaKAKMig4VUWdjZGCEN525oAKy3cDm2IBFlAWaNvGLTgDzWKGyrKipupwBqgciKlKA7AZDmN+ElBBAkUDOwgAAFaotiwLbZfcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/yddht-1.png
// module id = OIzR
// module chunks = 1